import { render, staticRenderFns } from "./header-navigation-tag.vue?vue&type=template&id=342e7cc4&scoped=true&"
import script from "./header-navigation-tag.vue?vue&type=script&lang=js&"
export * from "./header-navigation-tag.vue?vue&type=script&lang=js&"
import style0 from "./header-navigation-tag.vue?vue&type=style&index=0&id=342e7cc4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342e7cc4",
  null
  
)

export default component.exports